/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

import { wrapPageElement as wrap } from './root-wrapper';

export const wrapPageElement = wrap;
